import AbstractFileList from './AbstractFIleList';
export default class SharedFileList extends AbstractFileList {
  loadFileList() {
    // The in-flight and already-loaded guards live in FileListState.loadResults,
    // so every caller gets them — not just this one.
    this.fileState.loadResults();
  }
  hasMoreResults() {
    return this.fileState.hasMoreResults();
  }
  loadMore() {
    this.fileState.loadMore();
  }
  isLoading() {
    return this.fileState.isLoading();
  }
  fileCollection() {
    return this.fileState.files;
  }
}
flarum.reg.add('fof-upload', 'common/components/SharedFileList', SharedFileList);